module.exports = __webpack_public_path__ + "media/proximanova-regular.d670e5f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-regular.ttf
// module id = 104
// module chunks = 9